import clsxm from "@/lib/clsxm";
import {memo, type FC} from "react";

const Toggle: FC<{
  checked: boolean;
  onChange?: (value: boolean) => void;
  label?: string;
  disabled?: boolean;
}> = ({checked, onChange, label, disabled = false}) => {
  return (
    <label
      className={clsxm("relative mt-1 inline-flex cursor-pointer items-center", {
        "cursor-not-allowed": disabled,
      })}>
      <input
        type="checkbox"
        value=""
        className="peer sr-only"
        checked={checked}
        onChange={e => onChange && !disabled && onChange(e.target.checked)}
      />
      <div
        className={clsxm(
          "peer border-good-grey-400 after:bg-good-grey-400 h-6 w-12 rounded-full border-1 peer-checked:border-none peer-focus:ring-2 peer-focus:ring-blue-300 peer-focus:outline-hidden after:absolute after:top-[4px] after:left-[4px] after:h-4 after:w-4 after:rounded-full after:border after:transition-all after:content-[''] peer-checked:after:left-[10px] peer-checked:after:translate-x-full peer-checked:after:border-white peer-checked:after:bg-white",
          disabled ? "peer-checked:bg-neutral-grey-light" : "peer-checked:bg-primary-dark-solid",
        )}
      />
      {label && <span className="text-neutral-black ml-3 text-sm font-medium">{label}</span>}
    </label>
  );
};

export default memo(Toggle);
